import { loadData } from "./data/data-loader.js";
import { setupRedirectIfNeeded } from "./utils/navigation.js";
import { renderHeader } from "./components/header.js";
import { renderBonus } from "./components/bonus.js";
import { renderTopCasino } from "./components/top-casino.js";
import { renderTopGames } from "./components/top-games.js";
import { renderApp } from "./components/app.js";
import { renderFAQ } from "./components/faq.js";
import { renderAfterSupport } from "./components/after-support.js";

async function init() {
  try {
    renderFAQ();
    await loadData();
    renderApp();
    renderHeader();
    setupRedirectIfNeeded();
    renderBonus();
    renderTopCasino();
    renderTopGames();
    await renderAfterSupport();
    
  } catch (error) {
    console.error("❌ Failed to initialize application:", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    requestAnimationFrame(() => {
      setTimeout(init, 0);
    });
  });
} else {
  requestAnimationFrame(() => {
    setTimeout(init, 0);
  });
}

window.app = {
  init,
  reload: () => {
    document.querySelectorAll("[id]").forEach((el) => (el.innerHTML = ""));
    init();
  },
};
